import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import AddName from '../components/AddName';
import EventImage from '../components/EventImage';
import logo from './logo.png';
import './RegistrationPage.css';

function RegistrationPage() {
  const [names, setNames] = useState([]);
  const [events, setEvents] = useState([]);
  const [customEvent, setCustomEvent] = useState(null);
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const hasReloaded = localStorage.getItem('hasReloaded');

    if (!hasReloaded) {
      localStorage.setItem('hasReloaded', 'true');
      window.location.reload(); // Recarrega a página
    }
    console.log("REACT_APP_API_URL:", process.env.REACT_APP_API_URL);
    console.log("REACT_APP_IMAGE_URL:", process.env.REACT_APP_IMAGE_URL);

    // Buscar eventos ativos
    axios.get(`${process.env.REACT_APP_API_URL}/events`)
      .then((response) => {
        console.log("Eventos carregados:", response.data);
        const filteredEvents = response.data.filter((event) => event.flyer && event.active);
        // Ordenar eventos para garantir que o evento de sexta seja exibido primeiro
        const sortedEvents = filteredEvents.sort((a, b) => {
          if (a.day === 'friday') return -1;
          if (b.day === 'friday') return 1;
          return 0;
        });
        setEvents(sortedEvents);
      })
      .catch(error => {
        console.error("Houve um erro ao buscar os eventos!", error);
      });

    // Buscar evento personalizado
    axios.get(`${process.env.REACT_APP_API_URL}/custom-events`)
      .then((response) => {
        if (response.data.length > 0) {
          setCustomEvent(response.data[0]); // Exibir apenas o primeiro evento personalizado
        }
      })
      .catch(error => {
        console.error("Erro ao buscar o evento personalizado:", error);
      });
  }, []);

  const addName = (newNames) => {
    setNames((prevNames) => [...prevNames, ...newNames]);
  };
  

  const removeName = (index) => {
    setNames(names.filter((_, i) => i !== index));
  };

  const handleDaySelection = (day) => {
    setSelectedDays((prevSelectedDays) => {
      if (prevSelectedDays.includes(day)) {
        const updatedOptions = { ...selectedOptions };
        delete updatedOptions[day];
        setSelectedOptions(updatedOptions);
        return prevSelectedDays.filter(selectedDay => selectedDay !== day);
      } else {
        return [...prevSelectedDays, day];
      }
    });
  };

  const handleOptionChange = (day, option) => {
    setSelectedOptions(prevSelectedOptions => ({
      ...prevSelectedOptions,
      [day]: option
    }));
  };

  const generateTickets = async (namesToUse = null) => {
    // Usar nomes passados como parâmetro ou do estado
    const namesToProcess = namesToUse || names;
    
    if (selectedDays.length === 0) {
      await Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Por favor, selecione pelo menos um evento.',
        confirmButtonColor: '#2196F3'
      });
      return;
    }
    if (!namesToProcess || namesToProcess.length === 0) {
      await Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Por favor, adicione o nome completo.',
        confirmButtonColor: '#2196F3'
      });
      return;
    }

    if (selectedDays.some(day => !selectedOptions[day])) {
      await Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Por favor, selecione uma opção de ingresso para cada dia.',
        confirmButtonColor: '#2196F3'
      });
      return;
    }

    try {
      // Preparar nomes com ticketType - assumindo um único tipo por compra para simplificar
      // Se houver múltiplos dias, usamos o primeiro tipo selecionado
      const firstDay = selectedDays[0];
      const ticketType = selectedOptions[firstDay];
      
      // Mapear o tipo para o formato esperado
      let ticketTypeLabel = '';
      if (ticketType === 'pista') ticketTypeLabel = 'Pista';
      else if (ticketType === 'camarote') ticketTypeLabel = 'Camarote';
      else if (ticketType === 'camaroteOpen') ticketTypeLabel = 'Camarote Open';
      else if (ticketType === 'ingresso') ticketTypeLabel = 'Ingresso';

      // Calcular o valor total dos ingressos
      const totalAmount = selectedDays.reduce((total, day) => {
        const event = events.find(event => event.day === day) || customEvent;
        if (event) {
          const selectedOption = selectedOptions[day];
          const price = event[`${selectedOption}Price`];
          return total + (price ? price * namesToProcess.length : 0);
        }
        return total;
      }, 0);

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/payments/create-pix`, {
        transaction_amount: totalAmount,
        description: `Ingressos para o evento de ${selectedDays.join(', ')}`,
        email: 'email@example.com',
        identificationType: 'CPF',
        // identificationNumber: '40178012858', // gustavo
        identificationNumber: '14054009603', // debora
        // identificationNumber: '50111978000107', // enzo

        names: namesToProcess, // Envia os nomes processados
        day: selectedDays,
        ticketType: ticketTypeLabel // Envia o tipo de ingresso
      });

      const qrCode = response.data.point_of_interaction?.transaction_data?.qr_code;
      const totalPaidAmount = response.data.transaction_details?.total_paid_amount;
      const qrCodeBase64 = response.data.point_of_interaction?.transaction_data?.qr_code_base64;
      const paymentId = response.data.id;

      // Armazenar os valores no localStorage, se não forem undefined
      if (qrCode && totalPaidAmount && qrCodeBase64) {
        localStorage.setItem('qr_code', qrCode);
        localStorage.setItem('total_paid_amount', totalPaidAmount);
        localStorage.setItem('qr_code_base64', qrCodeBase64);
        localStorage.setItem('payment_id', paymentId);
      } else {
        console.error('Alguns dos valores estão undefined');
      }

      console.log("Resposta do backend:", response.data);

      const transactionData = response.data?.point_of_interaction?.transaction_data;

      if (transactionData) {
        console.log("QR Code URL:", transactionData.qr_code_base64);
        console.log("Payment URL:", transactionData.ticket_url);

        // Redirecionar para a página de pagamento
        navigate('/confirmation');
      } else {
        console.error("Dados de transação inválidos na resposta");
        alert("Houve um erro ao criar o pagamento!");
      }
    } catch (error) {
      console.error("Houve um erro ao criar o pagamento!", error);
      alert("Houve um erro ao criar o pagamento!");
    }
  };

  return (
    <div className="registration-page">
      <div className="registration-content">
        <img src={logo} alt="Logo" className="registration-logo" />

        {/* Exibir eventos regulares (Sexta e Sábado) */}
        {events.map((event) => (
          <div key={event._id} className="event-container">
            <div className="event-image-wrapper">
              <EventImage className="event-image" src={`${process.env.REACT_APP_IMAGE_URL}${event.flyer}`} />
            </div>
            <div className="event-prices">
              {event.pistaPrice && (
                <div className="price-badge">
                  <span className="price-label">Pista</span>
                  <span className="price-value">R$ {parseFloat(event.pistaPrice).toFixed(2).replace('.', ',')}</span>
                </div>
              )}
              {event.camarotePrice && (
                <div className="price-badge">
                  <span className="price-label">Camarote</span>
                  <span className="price-value">R$ {parseFloat(event.camarotePrice).toFixed(2).replace('.', ',')}</span>
                </div>
              )}
              {event.camaroteOpenPrice && (
                <div className="price-badge">
                  <span className="price-label">Camarote Open</span>
                  <span className="price-value">R$ {parseFloat(event.camaroteOpenPrice).toFixed(2).replace('.', ',')}</span>
                </div>
              )}
              {event.ingressoPrice && (
                <div className="price-badge">
                  <span className="price-label">Ingresso</span>
                  <span className="price-value">R$ {parseFloat(event.ingressoPrice).toFixed(2).replace('.', ',')}</span>
                </div>
              )}
            </div>
          </div>
        ))}

        {/* Exibir o evento personalizado se existir */}
        {customEvent && (
          <div key={customEvent._id} className="event-container">
            <div className="event-image-wrapper">
              <EventImage className="event-image" src={`${process.env.REACT_APP_IMAGE_URL}${customEvent.flyer}`} />
            </div>
            <div className="event-prices">
              {customEvent.pistaPrice && (
                <div className="price-badge">
                  <span className="price-label">Pista</span>
                  <span className="price-value">R$ {parseFloat(customEvent.pistaPrice).toFixed(2).replace('.', ',')}</span>
                </div>
              )}
              {customEvent.camarotePrice && (
                <div className="price-badge">
                  <span className="price-label">Camarote</span>
                  <span className="price-value">R$ {parseFloat(customEvent.camarotePrice).toFixed(2).replace('.', ',')}</span>
                </div>
              )}
              {customEvent.camaroteOpenPrice && (
                <div className="price-badge">
                  <span className="price-label">Camarote Open</span>
                  <span className="price-value">R$ {parseFloat(customEvent.camaroteOpenPrice).toFixed(2).replace('.', ',')}</span>
                </div>
              )}
              {customEvent.ingressoPrice && (
                <div className="price-badge">
                  <span className="price-label">Ingresso</span>
                  <span className="price-value">R$ {parseFloat(customEvent.ingressoPrice).toFixed(2).replace('.', ',')}</span>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Seção GARANTIR MINHA VAGA */}
        {events.length > 0 || customEvent ? (
          <div className="selection-section">
            <h3 className="section-title">1° - Selecione o evento e o setor abaixo</h3>
           
            {/* Eventos regulares (Sexta e Sábado) */}
            {events.map((event) => (
              <div key={event._id} className="event-option">
                <label>
                  <input
                    type="checkbox"
                    checked={selectedDays.includes(event.day)}
                    onChange={() => handleDaySelection(event.day)}
                  />
                  {event.day === 'friday' ? 'Sexta-feira' : event.day === 'saturday' ? 'Sábado' : event.day}
                </label>
                {selectedDays.includes(event.day) && (
                  <div className="ticket-options">
                    {event.pistaPrice && (
                      <div className="ticket-option">
                        <label>
                          <input
                            type="radio"
                            name={`option-${event.day}`}
                            value="pista"
                            onChange={() => handleOptionChange(event.day, 'pista')}
                            checked={selectedOptions[event.day] === 'pista'}
                          />
                          Pista
                        </label>
                      </div>
                    )}
                    {event.camarotePrice && (
                      <div className="ticket-option">
                        <label>
                          <input
                            type="radio"
                            name={`option-${event.day}`}
                            value="camarote"
                            onChange={() => handleOptionChange(event.day, 'camarote')}
                            checked={selectedOptions[event.day] === 'camarote'}
                          />
                          Camarote
                        </label>
                      </div>
                    )}
                    {event.camaroteOpenPrice && (
                      <div className="ticket-option">
                        <label>
                          <input
                            type="radio"
                            name={`option-${event.day}`}
                            value="camaroteOpen"
                            onChange={() => handleOptionChange(event.day, 'camaroteOpen')}
                            checked={selectedOptions[event.day] === 'camaroteOpen'}
                          />
                          Camarote Open
                        </label>
                      </div>
                    )}
                    {event.ingressoPrice && (
                      <div className="ticket-option">
                        <label>
                          <input
                            type="radio"
                            name={`option-${event.day}`}
                            value="ingresso"
                            onChange={() => handleOptionChange(event.day, 'ingresso')}
                            checked={selectedOptions[event.day] === 'ingresso'}
                          />
                          Ingresso
                        </label>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}

            {/* Evento personalizado na seção "GARANTIR MINHA VAGA" */}
            {customEvent && (
              <div className="event-option">
                <label>
                  <input
                    type="checkbox"
                    checked={selectedDays.includes('customEvent')}
                    onChange={() => handleDaySelection('customEvent')}
                  />
                  {customEvent.eventName}
                </label>
                {selectedDays.includes('customEvent') && (
                  <div className="ticket-options">
                    {customEvent.pistaPrice && (
                      <div className="ticket-option">
                        <label>
                          <input
                            type="radio"
                            name="option-customEvent"
                            value="pista"
                            onChange={() => handleOptionChange('customEvent', 'pista')}
                            checked={selectedOptions['customEvent'] === 'pista'}
                          />
                          Pista
                        </label>
                      </div>
                    )}
                    {customEvent.camarotePrice && (
                      <div className="ticket-option">
                        <label>
                          <input
                            type="radio"
                            name="option-customEvent"
                            value="camarote"
                            onChange={() => handleOptionChange('customEvent', 'camarote')}
                            checked={selectedOptions['customEvent'] === 'camarote'}
                          />
                          Camarote
                        </label>
                      </div>
                    )}
                    {customEvent.camaroteOpenPrice && (
                      <div className="ticket-option">
                        <label>
                          <input
                            type="radio"
                            name="option-customEvent"
                            value="camaroteOpen"
                            onChange={() => handleOptionChange('customEvent', 'camaroteOpen')}
                            checked={selectedOptions['customEvent'] === 'camaroteOpen'}
                          />
                          Camarote Open
                        </label>
                      </div>
                    )}
                    {customEvent.ingressoPrice && (
                      <div className="ticket-option">
                        <label>
                          <input
                            type="radio"
                            name="option-customEvent"
                            value="ingresso"
                            onChange={() => handleOptionChange('customEvent', 'ingresso')}
                            checked={selectedOptions['customEvent'] === 'ingresso'}
                          />
                          Ingresso
                        </label>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
            <AddName onAdd={addName} onGenerateTickets={generateTickets} />
          </div>
        ) : (
          <div className="no-events">
            <p>Aguarde Novidades...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default RegistrationPage;

